export default __webpack_public_path__ + "static/media/i028vp.51928118.webp";